import { getInstructionData } from "api";

import { Error } from "Responses/Response";
import { ActionTypes } from "./types";

export const GetInstruction = (payload) => async (dispatch) => {
  try {
    dispatch({ type: ActionTypes.LOADING });
    const { data, status } = await getInstructionData(payload);

    dispatch({
      type: ActionTypes.SUCCESS,
      payload: data,
    });
  } catch (error) {
    Error(error?.response?.data?.error);
    dispatch({
      type: ActionTypes.ERROR,
      payload: error,
    });
  }
};
